/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA
 */

import { resolveDisplayFormat, isLocalizedFormatsEnabled } from '@oat-sa-private/ui-core';
import env from '@/config/env';

/**
 * @param {object} configuration
 * @param {{ enabled?: boolean, dateFormats?: Record<string, object> }} appliedDateFormats
 * @returns {object}
 */
export function buildTenantConfigurationDiagnostics(configuration = {}, appliedDateFormats = {}) {
    return {
        settingsEnabled: Boolean(configuration?.dateFormats?.enabled),
        featureFlagEnabled: Boolean(configuration?.localisedDatesConfigEnabled),
        appliedLocalized: Boolean(appliedDateFormats?.enabled),
        uiLocalized: isLocalizedFormatsEnabled(),
        datetimePattern: resolveDisplayFormat({ hasHour: true }),
        shortDatePattern: resolveDisplayFormat({ isForm: true })
    };
}

/**
 * Stores and logs the latest tenant configuration diagnostics for manual debugging.
 * @param {object} configuration
 * @param {{ enabled?: boolean, dateFormats?: Record<string, object> }} appliedDateFormats
 * @returns {object}
 */
export function publishTenantConfigurationDiagnostics(configuration = {}, appliedDateFormats = {}) {
    const diagnostics = buildTenantConfigurationDiagnostics(configuration, appliedDateFormats);

    if (typeof window !== 'undefined') {
        window.__proctoringTenantConfig = diagnostics;
    }

    if (env('NODE_ENV') === 'local') {
        // eslint-disable-next-line no-console
        console.info('[proctoring] tenant configuration refreshed', diagnostics);
    }

    return diagnostics;
}
